module.exports = __webpack_public_path__ + "static/media/mc_balance.fd07950a.svg";